module.exports = __webpack_public_path__ + "img/404.e5d2f0dc.svg";